import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getStockist(params) {
	return client.get("transaksi/produk/list-stockist", {
		params: params,
	});
}

export default {
	getStockist,
};